"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./registration.response"), exports);
__exportStar(require("./demographics.response"), exports);
__exportStar(require("./coverage.response"), exports);
__exportStar(require("./consent.response"), exports);
__exportStar(require("./merge.response"), exports);
__exportStar(require("./search.response"), exports);
__exportStar(require("./protection.response"), exports);
__exportStar(require("./identity-resolution.response"), exports);
// ---------------------------------------------------------------------------
// Appointment bounded context (Stage 5B.5)
// ---------------------------------------------------------------------------
__exportStar(require("./appointment-common.response"), exports);
__exportStar(require("./booking.response"), exports);
__exportStar(require("./scheduling.response"), exports);
__exportStar(require("./check-in.response"), exports);
__exportStar(require("./queue.response"), exports);
__exportStar(require("./waitlist.response"), exports);
__exportStar(require("./slot-management.response"), exports);
__exportStar(require("./doctor-availability.response"), exports);
__exportStar(require("./reminder.response"), exports);
// ---------------------------------------------------------------------------
// Financial bounded context (Stage 5C.4)
// ---------------------------------------------------------------------------
__exportStar(require("./financial-common.response"), exports);
__exportStar(require("./financial-payment.response"), exports);
__exportStar(require("./financial-receipt.response"), exports);
__exportStar(require("./financial-advance-deposit.response"), exports);
__exportStar(require("./financial-refund.response"), exports);
__exportStar(require("./financial-refund-request.response"), exports);
__exportStar(require("./financial-payment-correction.response"), exports);
__exportStar(require("./financial-correction-stage.response"), exports);
__exportStar(require("./financial-receipt-correction.response"), exports);
__exportStar(require("./financial-correction-workflow.response"), exports);
__exportStar(require("./financial-patient-correction.response"), exports);
__exportStar(require("./financial-ip-drug-cancel.response"), exports);
__exportStar(require("./financial-correction-register.response"), exports);
__exportStar(require("./financial-correction-report.response"), exports);
__exportStar(require("./financial-tariff.response"), exports);
__exportStar(require("./financial-package.response"), exports);
__exportStar(require("./financial-discount.response"), exports);
__exportStar(require("./financial-posting.response"), exports);
__exportStar(require("./financial-approval.response"), exports);
__exportStar(require("./financial-billing.response"), exports);
__exportStar(require("./op-billing.response"), exports);
__exportStar(require("./op-billing-register.response"), exports);
__exportStar(require("./financial-journal.response"), exports);
__exportStar(require("./financial-general-ledger.response"), exports);
__exportStar(require("./financial-chart-of-accounts.response"), exports);
__exportStar(require("./financial-receivable.response"), exports);
__exportStar(require("./financial-payable.response"), exports);
__exportStar(require("./financial-cash-bank.response"), exports);
__exportStar(require("./financial-adjustment.response"), exports);
// ---------------------------------------------------------------------------
// Clinical bounded context (Stage 6C.4)
// ---------------------------------------------------------------------------
__exportStar(require("./clinical-common.response"), exports);
__exportStar(require("./clinical-encounter.response"), exports);
__exportStar(require("./clinical-document.response"), exports);
__exportStar(require("./clinical-order.response"), exports);
__exportStar(require("./clinical-timeline.response"), exports);
__exportStar(require("./clinical-approval.response"), exports);
__exportStar(require("./financial-appointment-correction.response"), exports);
//# sourceMappingURL=index.js.map